import { showLightbox } from './lightbox';

export default () => {
  const userMenu = $('.user-menu');
  userMenu.on('click', (e) => {
    e.preventDefault();
    if (userMenu.find('.user-menu__saved').length) {
      showLightbox(null, 'tools');
    }
    else {
      showLightbox('Login to <a href="/your-tools/save-and-compare">save and compare</a>', 'login');
    }
  });
};
